<div style="background-color: #ffffff" style="padding: 20px;">
  <!-- <div>
    <app-check-input
      [(ngModel)]="discountOrCredit"
      [label]="'Discount or credit'"
    ></app-check-input>
  </div> -->
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; gap: 20px; margin-bottom: 30px;">
    <div style="display: flex; gap: 30px;">
      <button
      class="cpo-add-new-item-tabs"
      [class.active-tab]="selectedTabTitle === 'Add New Item'"
      (click)="selectedTabTitle = 'Add New Item'"
      >Add New Item</button>
      <button
      class="cpo-add-new-item-tabs"
      [class.active-tab]="selectedTabTitle === 'Discount or Credit'"
      (click)="selectedTabTitle = 'Discount or Credit'"
      > Add Discount or Credit</button>
    </div>
    <div>
      <span style="font-family: Booton; color: var(--green-800); font-size: 20px; font-weight: 300; cursor: pointer;" (click)="handleCancelClicked()">X</span>
    </div>
  </div>

  <div style="display: flex; flex-direction: column; gap: 10px;" [hidden]="selectedTabTitle !== 'Add New Item'">
    <div style="display: flex;">
      <app-textbox
        [label]="'Item Name'"
        [(ngModel)]="customCatalogItem.name"
        [required]="true"
      ></app-textbox>
      <app-textbox
        [label]="'Item Description'"
        [(ngModel)]="customCatalogItem.description"
        [required]="false"
      ></app-textbox>
    </div>
    <div style="display: flex;">
      <app-textbox
        [label]="discountOrCredit ? 'Credit Amount' : 'Item Price'"
        [type]="TextModes.CurrencyUSD"
        [(ngModel)]="customCatalogItem.price"
        [validateOn]="'change'"
        [required]="true"
      ></app-textbox>
      <app-textbox
        [hidden]="discountOrCredit"
        [label]="'Item Quantity'"
        [(ngModel)]="customCatalogItemQuantity"
        [required]="true"
      ></app-textbox>
    </div>
    <div style="display: flex;">
      <app-checkbox
        [(ngModel)]="saveToCatalog"
        [label]="'Save to a catalog'"
      ></app-checkbox>
    </div>
    <div style="display: flex;" [hidden]="!saveToCatalog">
      <app-selectbox
        [label]="'Select a catalog'"
        [(ngModel)]="catalogId"
        [options]="catalogOptions"
        (onChanged)="handleCatalogNameChanged($event)"
      ></app-selectbox>        
    </div>
  </div>
  <div style="display: flex; flex-direction: column; gap: 10px;" [hidden]="selectedTabTitle !== 'Discount or Credit'">
    <div style="display: flex;">
      <app-textbox
        [label]="'Name'"
        [(ngModel)]="customCatalogItem.name"
        [required]="true"
      ></app-textbox>
      <app-textbox
        [label]="'Description'"
        [(ngModel)]="customCatalogItem.description"
        [required]="true"
      ></app-textbox>
    </div>
    <div style="display: flex;">
      <app-textbox
        [label]="'Amount'"
        [type]="TextModes.CurrencyUSD"
        [(ngModel)]="customCatalogItem.price"
        [validateOn]="'change'"
        [required]="true"
      ></app-textbox>
    </div>
    <div style="display: flex;">
      <app-checkbox
        [(ngModel)]="saveToCatalog"
        [label]="'Save to a catalog'"
      ></app-checkbox>
    </div>
    <div style="display: flex;" [hidden]="!saveToCatalog">
      <app-selectbox
        [label]="'Select a catalog'"
        [(ngModel)]="catalogId"
        [options]="catalogOptions"
        (onChanged)="handleCatalogNameChanged($event)"
      ></app-selectbox>        
    </div>
  </div>

  <div style="display: flex; gap: 10px; justify-content: flex-end; margin-top: 20px;">
    <input
      type="button"
      value="Cancel"
      class="btn-secondary"
      (click)="handleCancelClicked()"
    />
    <input
      type="button"
      value="Create Item"
      class="btn-primary"
      (click)="handleAddItemClicked()"
    />
  </div>
</div>
